import type { BusinessContactFormIds } from '@/types/forms'

export const BUSINESS_CONTACT_FORM_ID = 'business_contact_form'

export const BUSINESS_CONTACT_FORM_TYPE = 'contact'

export const BUSINESS_NAME_INPUT_ID = 'business_name_input'
export const BUSINESS_OWNER_INPUT_ID = 'business_owner_input'
export const BUSINESS_ADDRESS_INPUT_ID = 'business_address_input'
export const BUSINESS_CITY_INPUT_ID = 'business_city_input'
export const BUSINESS_STATE_INPUT_ID = 'business_state_input'
export const BUSINESS_ZIP_INPUT_ID = 'business_zip_input'
export const BUSINESS_PHONE_INPUT_ID = 'business_phone_input'
export const BUSINESS_EMAIL_INPUT_ID = 'business_email_input'

export const BUSINESS_CONTACT_SUBMIT_BUTTON_ID = 'business_contact_submit_button'

export const BUSINESS_CONTACT_FORM_FIELD_IDS = {
	name: BUSINESS_NAME_INPUT_ID,
	owner: BUSINESS_OWNER_INPUT_ID,
	address: BUSINESS_ADDRESS_INPUT_ID,
	city: BUSINESS_CITY_INPUT_ID,
	state: BUSINESS_STATE_INPUT_ID,
	zip: BUSINESS_ZIP_INPUT_ID,
	phone: BUSINESS_PHONE_INPUT_ID,
	email: BUSINESS_EMAIL_INPUT_ID,
	submit: BUSINESS_CONTACT_SUBMIT_BUTTON_ID
} as const satisfies BusinessContactFormIds
